import mutations from './illnessSelect.mutations'
import actions from './illnessSelect.actions'
import getters from './illnessSelect.getters'

import initialState from './defaultState'

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
